import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Params,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { selectors } from '@lbmx/app-state';
import { UserState } from '@lbmx/types';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DefaultRouteService implements CanActivate {
  constructor(private router: Router, private store: Store<UserState>) {}

  private buildRedirect(url: string, queryParams: Params) {
    const next = this.router.parseUrl(url);
    next.queryParams = queryParams;
    return next;
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.pipe(
      select(selectors.userProfile),
      switchMap((profile) => {
        return of(
          !profile.defaultModule || this.buildRedirect(profile.defaultModule, route.queryParams)
        );
      }),
      catchError(() => of(this.buildRedirect('/home', route.queryParams)))
    );
  }
}
